const Statistic = ({ data }) => {
  return (
    <>
      <div>
        {data?.drafts && (
          <>
            <h4>Drafts</h4>
            <p>{data?.drafts || 0}</p>
          </>
        )}
        {data?.published && (
          <>
            <h4>Published</h4>
            <p>{data?.published || 0}</p>
          </>
        )}
      </div>
      {!data?.drafts && !data?.published && (
        <>You don't have any published or draft articles.</>
      )}
    </>
  );
};

export default Statistic;
